import { AppMessagesContext, actionSetProgressMessage, Localization } from "@viamap/viamap2-common";
import { Spinner } from "react-bootstrap";
import { ProtectedFeature } from "src/components/ProtectedFeature";
import { ExportData } from "src/managers/ExportData";
import { MitStorage } from "src/managers/MitStorage";
import { SheetFunc } from "src/managers/SheetFunc";
import { ViewButtonCheck, ViewButtonIcon } from "./PropertyComponents";
import { PropertyData } from "./PropertyInfoCollectorTypes";
import { Feature } from "src/states/ApplicationStateFeatures";
import { CondominiumView } from "./CondominiumView";
import { AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { useState, useContext, useEffect } from "react";
import { ManagedWindow } from "src/WindowManager/WindowState";
import { MIBIcon } from "src/componentsUtils/MIBIcon";

type Props = {
  managedWindow: ManagedWindow;
  callBackOnClose: () => void;
  bfeNr?: { bfeNr: string | number };
  allowExtendedInformation: boolean;
};

export function CondominiumDialog(props: Props) {
  const [propertyDefaultCollapsed, setPropertyDefaultCollapsed] =
    useState(MitStorage.getValue<boolean>("EjerlejlighedAutoColapsed"));
  const { dispatch: appMessageDispatch } = useContext(AppMessagesContext);

  const [isLoading, setIsLoading] = useState(true);
  const [propertyData, setPropertyData] = useState<any>();

  useEffect(() => {
    setIsLoading(true);
  }, [props.bfeNr]);

  function RemberCollapseSettings(e: any, val) {
    MitStorage.setValue<boolean>("EjerlejlighedAutoColapsed", !val);
  }

  // MARK: Fix
  // oxlint-disable-next-line no-unused-vars
  async function handleExportToExcel() {
    let wb = await (new ExportData()).createPropertyDataExcelExport(
      "Property Export",
      new Date(),
      propertyData,
      (progress: number) => {
        appMessageDispatch(actionSetProgressMessage("Export", Math.round(100 * progress / 1)));
      });
    let blob = SheetFunc.createBlob(wb);
    let fileName = "PropertyData" + (propertyData?.BBRRel?.bfeNummer || "");
    fileName += ".xlsx";
    ExportData.downloadBlob(fileName, blob);
  }

  let fold = (
    <ViewButtonCheck
      checked={!propertyDefaultCollapsed}
      className="no-print"
      onCheck={(e, val) => {
        RemberCollapseSettings(e, val);
        setPropertyDefaultCollapsed(val);
      }}
    >
      {Localization.getText("Expanded")}
    </ViewButtonCheck>
  );

  return (
    <AdvancedDragModal
      window={props.managedWindow}
      onClose={props.callBackOnClose}
      title={Localization.getText("Condominium")}
      PosDefault={{ width: "800px", height: "calc(100% - 50px)", top: "50px", left: "50%", transform: "translateX(-50%)" }}
      subHeaderContent={

        <>
          <h4 className="no-print">{ }</h4>
          <ProtectedFeature
            feature={Feature.NotActive}
            contentsIfNoAccess={<></>}
          >
            Tilføj til Projekt
          </ProtectedFeature>
          <ProtectedFeature
            feature={Feature.PrintPropertyInfo}
            contentsIfNoAccess={<></>}
          >
            <>
              {!isLoading ? (
                <>
                  <ViewButtonIcon
                    className="no-print"
                    onClick={() => {
                      print();
                    }}
                    title={Localization.getText("Print")}
                  >
                    <MIBIcon icon="print" />
                  </ViewButtonIcon>
                </>
              ) : (
                <Spinner size="sm" />
              )}
            </>
          </ProtectedFeature>
          {fold}
        </>
      }
    >


      {(props.bfeNr && (
        <CondominiumView
          key={props.bfeNr.bfeNr}
          foldetUd={!propertyDefaultCollapsed}
          cols={1}
          bfeNr={props.bfeNr.bfeNr}
          callBackOnLoaded={(data: PropertyData) => {
            setIsLoading(false);
            setPropertyData(data);
          }}
          allowExtendedInformation={true}
        />
      )) ||
        "Missing Dot"}
    </AdvancedDragModal>
  );
  // 706899 Bygning på fremmedgrund
}
